var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{on:{"input":_vm.handleChange},model:{value:(_vm.row.isEnabled),callback:function ($$v) {_vm.$set(_vm.row, "isEnabled", $$v)},expression:"row.isEnabled"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v("启用")]),_c('el-radio',{attrs:{"label":1}},[_vm._v("禁用")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }